// extracted by mini-css-extract-plugin
module.exports = {"root":"WebhooksStatistics_root__1VXeq","title":"WebhooksStatistics_title__2i7vX","text":"WebhooksStatistics_text__5xMDE","grid":"WebhooksStatistics_grid__12nzD"};